export const COLOR_OPTIONS = {
  primaryBlue: '#002d72',
  black: '#000000',
  lightBlue: '#0064fe',
  green: '#548d25',
  cyanBlue: '#597ba2',
  orange: '#ff4c31',
  lightGray: '#686b75',
  cyanBlueDark: '#3a6774',
  magenta: '#7441b5',
  red: '#d10b0b',
  maroon: '#a4002b',
  darkBrown: '#6e4f35',
  darkGray: '#25200e',
  darkBlue: '#1f2043',
  primaryYellow: '#ffe500',
  white: '#ffffff',
  whiteWithPromo: 'whiteWithPromo', // To include promotion option, but just with white background
};
